import React from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

// Define styles for the PDF
const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: '#FFFFFF',
        padding: 30,
        fontFamily: 'Helvetica',
    },
    section: {
        marginVertical: 8,
        padding: 10,
        borderBottomWidth: 1,
        borderBottomColor: '#000',
        borderBottomStyle: 'solid',
    },
    header: {
        fontSize: 22,
        marginBottom: 8,
        textAlign: 'center',
    },
    text: {
        fontSize: 11,
        marginBottom: 4,
        textAlign: 'justify',
        lineHeight: 1.2,
    },
    subHeader: {
        fontSize: 16,
        marginBottom: 6,
        fontWeight: 'bold',
        backgroundColor: '#e0e0e0',
        padding: 4,
        borderColor: '#ccc',
        borderWidth: 1,
        borderStyle: 'solid',
    },
    twoColumnLayout: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    leftColumn: {
        flex: 1,
        marginRight: 4,
    },
    rightColumn: {
        flex: 1,
        marginLeft: 4,
    },
});

// Utility function to render arrays as lines of text
const renderArrayAsText = (array) => {
    if (Array.isArray(array)) {
        return array.map((item, index) => (
            <Text key={index} style={styles.text}>
                {item}
            </Text>
        ));
    }
    return <Text style={styles.text}>{array}</Text>;
};

// Main ResumePDF component
const ResumePDF = ({ name, title, location, email, phone, summary, experience, skills, education, publications }) => {
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                {/* Header Section */}
                <View style={styles.section}>
                    <Text style={styles.header}>{name}</Text>
                    <Text style={styles.text}>{title}</Text>
                    <Text style={styles.text}>
                        {location} | {email} | {phone}
                    </Text>
                </View>

                {/* Summary Section */}
                <View style={styles.section}>
                    <Text style={styles.subHeader}>Summary</Text>
                    {renderArrayAsText(summary)}
                </View>

                {/* Professional Experience Section */}
                <View style={styles.section}>
                    <Text style={styles.subHeader}>Professional Experience</Text>
                    {renderArrayAsText(experience)}
                </View>

                {/* Two Column Layout for Skills and Education */}
                <View style={styles.twoColumnLayout}>
                    <View style={styles.leftColumn}>
                        <View style={styles.section}>
                            <Text style={styles.subHeader}>Skills</Text>
                            {renderArrayAsText(skills)}
                        </View>
                        <View style={styles.section}>
                            <Text style={styles.subHeader}>Education</Text>
                            {renderArrayAsText(education)}
                        </View>
                    </View>
                    <View style={styles.rightColumn}>
                        <View style={styles.section}>
                            <Text style={styles.subHeader}>Publications</Text>
                            {renderArrayAsText(publications)}
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default ResumePDF;